import styled, { keyframes, css } from 'styled-components';

const rotate = keyframes`
   0%   {transform: rotate(0deg)}
    100%   {transform: rotate(360deg)}
`;

const prixClipFix = keyframes`
  0%   {clip-path:polygon(50% 50%,0 0,0 0,0 0,0 0,0 0)}
      50%  {clip-path:polygon(50% 50%,0 0,100% 0,100% 0,100% 0,100% 0)}
      75%, 100%  {clip-path:polygon(50% 50%,0 0,100% 0,100% 100%,100% 100%,100% 100%)}
`;

export const SpinLoader = styled.div<{ width?: string; height?: string }>`
  width: ${({ width }) => (width ? width : '48px')};
  height: ${({ height }) => (height ? height : '48px')};
  border-radius: 50%;
  position: relative;
  animation: ${rotate} 1.5s infinite ease-in;
  &::before {
    content: '';
    box-sizing: border-box;
    position: absolute;
    inset: 0px;
    border-radius: 50%;
    border: 5px solid #fff;
    animation: ${prixClipFix} 1.5s infinite ease-in;
  }
  &::after {
    transform: rotate3d(90, 90, 0, 180deg);
    border-color: rgba(32, 154, 214, 1);
    content: '';
    box-sizing: border-box;
    position: absolute;
    inset: 0px;
    border-radius: 50%;
    border: 5px solid rgba(32, 154, 214, 1);
    animation: ${prixClipFix} 1.5s infinite ease-in;
  }
`;
